




















//@ts-ignore
import store from "../../store";
import {Component, Vue} from "vue-property-decorator";
import {
    AutomationPlayerMap,
    CurrentGame,
    GameAutomation,
    GameSettings,
    Player, PlayerAutomationStatus,
    PlayerRole,
    PlayerSymbols
} from "../../../types";
import {Tool} from "../../helpers/Tool";

@Component({
    props: {
        player: {
            required: true,
            type: Object
        }
    }
})

export default class PlayerIcon extends Vue {
    private isInverted: boolean = false;
    private player!: Player;

    /**
     * Данные игрока
     */
    private get playerData():any
    {

        if (typeof store.getters.getGameState.playersData === "undefined") {
            return null;
        }

        let playersData = store.getters.getGameState.playersData;

        if (typeof playersData[this.player.id] === "undefined") {
            return null;
        }

        return playersData[this.player.id];
    }

    private get playerIsWatcher(): boolean
    {
        return this.playerData.icon === 'ic_eye';
    }

    /**
     * Иконка игрока
     */
    private get playerIcon(): string
    {

        if (!this.playerData || !this.playerData.icon) {
            return '';
        }

        if (this.playerData.icon.indexOf('inverted') === -1) {
            this.isInverted = false;
        } else {
            this.isInverted = true;
        }

        return '#' + this.playerData.icon;
    }

    /**
     * Id для поля игрока
     * @param field
     * @return {string}
     */
    private getPlayerFieldId(field: string): string
    {
        return Tool.createPlayerFieldId(field, this.player.id);
    }
}
